import Vue from 'vue';
import Guard1000FaultEvents from '@/resources/guard-1000-fault-events';
import PaginatedList from './mixins/paginated-list';
import Guard1000FaultWaveform from '@/resources/guard-1000-fault-event-waveform';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import jsona from '@/lib/jsona';
import { createSeries } from '@/utils/store/phasesFeedersHelpers';

const MODULE_NAME = 'guard1000FaultEvents';
export default {
  namespaced: true,
  ...PaginatedList(
    Guard1000FaultEvents,
    {
      state: {
        waveforms: {}
      },
      mutations: {
        addWaveform(state, { id, data }) {
          const parsedData = Object.freeze(camelcaseKeysDeep(jsona.deserialize(data)));

          Vue.set(state.waveforms, id, parsedData);
        }
      },
      actions: {
        // Not using global loader method to make ux better
        async fetchWaveform({ commit }, { externalGuardId, id }) {
          try {
            const waveform = await Guard1000FaultWaveform({ externalGuardId, id }).get();

            if (!waveform) return Error('Error when fetching fault event waveform');

            commit('addWaveform', { id, data: waveform.data });
          } catch (responseError) {
            return false;
          }
        }
      },
      getters: {
        getWaveform: state => id =>
          createSeries(state.waveforms[id] ? [state.waveforms[id]] : [])[0] || []
      }
    },
    MODULE_NAME
  )
};
